module.exports = __webpack_public_path__ + "media/images/riders/MATHIAS_FLUECKIGER-c71a264c8d6e05a1035e8508dab43722.png";